/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.182 1.905h-2.727V0h-1.819v5.714h1.818v-1.9h2.727V18.1H1.818V3.81h1.818V1.905H1.818A1.863 1.863 0 000 3.81V18.1A1.863 1.863 0 001.818 20h16.364A1.863 1.863 0 0020 18.1V3.81a1.863 1.863 0 00-1.818-1.905zM6.364 3.81h6.364V1.905H6.364V0H4.546v5.714h1.818v-1.9zm.909 3.809H3.636v3.81h3.636v-3.81zm4.545 0H8.182v3.81h3.636v-3.81zm.909 3.81h3.636v-3.81h-3.636v3.81zM3.636 16.19h3.636v-3.809H3.636v3.809zm4.545 0h3.636v-3.809H8.182v3.809z" _fill="#f7223f" fill-rule="evenodd"/>'
  }
})
